import { Injectable } from '@angular/core';

import { IBetError, IBetErrorDoc } from '@frontend/oxygen/shared-utils';
import * as _ from 'underscore';

import { BetError } from './bet-error';

@Injectable({ providedIn: 'root' })
export class BetErrorService {
    parse(doc: IBetErrorDoc): BetError {
        return new BetError(doc);
    }

    parseErrors(docs: IBetErrorDoc[]): BetError[] | IBetError[] {
        return _.map(docs, this.parse);
    }
}
